import { getTimes } from "suncalc";
import { Sunrise, Sunset, Sun } from "lucide-react";

const fmt = (d) => (d instanceof Date && !isNaN(d) ? d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }) : "—");

// Today's light at this exact spot — for planning a shoot.
export const SunTimes = ({ lat, lng }) => {
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    const t = getTimes(new Date(), lat, lng);
    const rows = [
        { Icon: Sunrise, label: "Sunrise", value: fmt(t.sunrise) },
        { Icon: Sun, label: "Morning gold", value: `${fmt(t.sunrise)}–${fmt(t.goldenHourEnd)}` },
        { Icon: Sun, label: "Evening gold", value: `${fmt(t.goldenHour)}–${fmt(t.sunset)}` },
        { Icon: Sunset, label: "Sunset", value: fmt(t.sunset) },
    ];
    return (
        <div data-testid="sun-times" className="mt-4 p-3 rounded-2xl bg-amber-50 border border-amber-200">
            <div className="text-[10px] uppercase tracking-widest font-bold text-amber-800 mb-2">Light here today</div>
            <div className="grid grid-cols-1 gap-y-1.5">
                {rows.map(({ Icon, label, value }) => (
                    <div key={label} className="flex items-center gap-1.5 text-xs">
                        <Icon size={12} className="text-amber-700 shrink-0" />
                        <span className="text-muted-foreground">{label}</span>
                        <span className="ml-auto font-bold tabular-nums" data-testid={`sun-${label.toLowerCase().replace(" ", "-")}`}>{value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
